'use strict';

var emailValidation = require('../../../../../../../../_virtual/emailValidation.cjs');

const emailRegex = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
/**
 * Check if email is present
 */ const isEmailPresent = (email)=>!!email;
/**
 * Check if email contains an @ character
 */ const isEmailAtValid = (email)=>email.includes("@");
/**
 * Check if email contains a dot character
 */ const isEmailDotValid = (email)=>email.includes(".");
/**
 * Check if email is valid, comparing it against a regex
 */ const isEmailRegexValid = (email)=>emailRegex.test(email);

emailValidation.__exports.isEmailAtValid = isEmailAtValid;
emailValidation.__exports.isEmailDotValid = isEmailDotValid;
emailValidation.__exports.isEmailPresent = isEmailPresent;
emailValidation.__exports.isEmailRegexValid = isEmailRegexValid;

module.exports = emailValidation.__exports;
//# sourceMappingURL=emailValidation.cjs.map
